import {
  InMemoryHeader,
  InMemoryString,
  InMemoryBoolean,
  InMemoryDate,
  InMemoryInteger,
  InMemoryDecimal,
  HeaderAlignment,
} from "pbas-vue-components";
import {
  translate
} from '../trans'
import store from '@/store'
import { translate2 } from '../trans2'
import { i18n } from '@/plugins/i18n';

export default [
  new InMemoryHeader({
    title: "headers.pendinghourreports.Id",
    type: new InMemoryString("Id"),
    sortable: true,
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
    version: 1,
  }),
  new InMemoryHeader({
    title: "headers.pendinghourreports.PendingImportId",
    type: new InMemoryString("PendingImportId"),
    sortable: false,
    visible: false,
    searchable: false,
    allowVisibilityChange: false,
  }),
  new InMemoryHeader({
    title: "headers.pendinghourreports.MemberCertificate",
    type: new InMemoryString("MemberCertificate"),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new InMemoryHeader({
    title: "headers.pendinghourreports.SIN",
    type: new InMemoryString("SIN"),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new InMemoryHeader({
    title: "headers.pendinghourreports.FirstName",
    type: new InMemoryString("FirstName"),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new InMemoryHeader({
    title: "headers.pendinghourreports.LastName",
    type: new InMemoryString("LastName"),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new InMemoryHeader({
    title: "headers.pendinghourreports.Gender",
    type: new InMemoryString("Gender"),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new InMemoryHeader({
    title: "headers.pendinghourreports.DateOfBirth",
    type: new InMemoryDate("DateOfBirth", {
      getString: (item, type) => {
        function parseValue(dateString) {
            if (dateString === undefined || dateString === null) {
                return "";
            }
            const [date, time] = dateString.split("T");
            const [year, month, day] = date.split("-");
            return `${year}-${month}-${day}`;
        }
        const parsed = parseValue(item.DateOfBirth);
        return parsed;
      }
    }),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new InMemoryHeader({
    title: "headers.pendinghourreports.Employer",
    type: new InMemoryString("Employer"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "headers.pendinghourreports.EmployeeNumber",
    type: new InMemoryString("EmployeeNumber"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "headers.pendinghourreports.Store",
    type: new InMemoryString("Store"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "headers.pendinghourreports.Frequency",
    type: new InMemoryString("Frequency"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new InMemoryHeader({
    title: "headers.pendinghourreports.EmploymentType",
    type: new InMemoryString("EmploymentType"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new InMemoryHeader({
    title: "headers.pendinghourreports.HireDate",
    type: new InMemoryDate("HireDate", {
      getString: (item, type) => {
        function parseValue(dateString) {
            if (dateString === undefined || dateString === null) {
                return "";
            }
            const [date, time] = dateString.split("T");
            const [year, month, day] = date.split("-");
            return `${year}-${month}-${day}`;
        }
        const parsed = parseValue(item.HireDate);
        return parsed;
      }
    }),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new InMemoryHeader({
    title: "headers.pendinghourreports.Earnings",
    type: new InMemoryDecimal("Earnings"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new InMemoryHeader({
    title: "headers.pendinghourreports.TermName",
    type: new InMemoryString("TermName"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  // new InMemoryHeader({
  //   title: "headers.pendinghourreports.TermYear",
  //   type: new InMemoryString("TermYear"),
  //   sortable: true,
  //   visible: false,
  //   searchable: true,
  //   allowVisibilityChange: false,
  //   version: 2
  // }),
  new InMemoryHeader({
    title: "headers.pendinghourreports.TerminationDate",
    type: new InMemoryDate("TerminationDate", {
      getString: (item, type) => {
        function parseValue(dateString) {
            if (dateString === undefined || dateString === null) {
                return "";
            }
            const [date, time] = dateString.split("T");
            const [year, month, day] = date.split("-");
            return `${year}-${month}-${day}`;
        }
        const parsed = parseValue(item.HireDate);
        return parsed;
      }
    }),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new InMemoryHeader({
    title: "headers.pendinghourreports.TerminationReason",
    type: new InMemoryString("TerminationReason"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "headers.pendinghourreports.Amount",
    type: new InMemoryDecimal("Amount"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new InMemoryHeader({
    title: "headers.pendinghourreports.ContributionAmount",
    type: new InMemoryDecimal("ContributionAmount"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new InMemoryHeader({
    title: "headers.pendinghourreports.EmployerRate",
    type: new InMemoryDecimal("EmployerRate"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new InMemoryHeader({
    title: "headers.pendinghourreports.ExpectedContribution",
    type: new InMemoryDecimal("ExpectedContribution"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new InMemoryHeader({
    title: "headers.pendinghourreports.ContributionDiff",
    type: new InMemoryDecimal("ContributionDiff"),
    sortable: true,
    visible: true,
    searchable: true
  }),
];
